import './App.scss'; 
import './title.scss'; 
import Banner from './Banner';
import {Projects, ProjectsHandle} from './Projects/Projects'; 
import Timeline from './Timeline'; 
import { useRef } from 'react';


export default function App() {  

  const projectHandle = useRef<ProjectsHandle>(null);

  return (  
    <div className="App">  
      <Banner></Banner>
      <main>  
        <section id="sec-about">
          <h1>
            <div id="firstname" className="firstname">Florian</div>
            <div className="lastname">AUBER<wbr/>VAL</div> 
            <div className="subtitle">Ingénieur en informatique graphique</div> 
          </h1> 
            <p>
            Passionné par l'intégration de la technologie dans la production visuelle et créative. 
            Je suis spécialisé dans le parallélisme des calculs et dans les méthodes de rendu visuel 3D, temps réel et photo-réaliste.
            </p>
          <h2>Parcours</h2> 
          <Timeline goToProject={(name : string) => projectHandle.current?.goToProject(name)}></Timeline>
        </section> 
        <section id="sec-projects">
          <h2>Projets</h2> 
          <Projects ref={projectHandle}></Projects> 
        </section>
        <section id="sec-contact">
          <h2>Contact</h2> 
          <form id="contact" action="https://api.web3forms.com/submit" method="POST">
            <input type="hidden" name="access_key" value="23dafa05-30af-469f-8d6d-0d3ceb5a6534"/>
            <input type="email" placeholder="Votre email" id="email" name="email" required/>
            <select name="subject" id="subject" defaultValue={""} required>
              <option disabled value="">Selectionnez un sujet</option>
              <option value="hiring">Proposition de recrutement</option>
              <option value="other">Autre sujet</option>
            </select>
            <textarea required placeholder="Votre message" id="message" name="message"/>
            <input type="checkbox" name="botcheck" className="hidden" style={{display: 'none'}}/>
            <button type="submit">Envoyer le message</button> 
          </form>
        </section> 
      </main>
    </div>
  );
};
 
